import { Component } from '@angular/core';
import { AccountService } from '../../../services/account.service';
import { CommunicationService } from '../../../services/communication.service';
import { PermissionsService } from '../../../services/permissions.service';
import { publicMethods } from '../../../globals';

@Component({
    selector: 'bulk-download-management',
    templateUrl: './bulk-download-management.component.html',
    styleUrl: './bulk-download-management.component.css',
    standalone: false
})
export class BulkDownloadManagementComponent {
  isParentOrgSuperUser = false;
  bulkDownloadDetails = [];

  organisationTeams = [];
  organisationUsers = [];

  constructor(
    private accountService: AccountService,
    private commService: CommunicationService,
    private permissionsService: PermissionsService,
    private pubMethods: publicMethods
  ) {}

  ngOnInit(): void {
    this.commService
      .getIsParentOrgSuperUserMessage()
      .subscribe(isParentOrgSuperUser => {
        this.isParentOrgSuperUser = isParentOrgSuperUser;
        if (this.isParentOrgSuperUser) {
          this.permissionsService
            .getSuperuserTeamsAndUsers()
            .subscribe(data => {
              this.organisationTeams = data.organisation_teams;
              this.organisationUsers = data.organisation_users;
              this.getBulkDownloadDetails();
            });
        }
      });
  }

  getBulkDownloadDetails(): void {
    this.accountService.getBulkDownloadDetails().subscribe(response => {
      if (this.pubMethods.hasData(response)) {
        this.bulkDownloadDetails = response;
      }
    });
  }

  handlePermissionChange(event: any) {
    const { userId, id: teamId, selected } = event;
    const permissionId = this.bulkDownloadDetails[0].id;
    const postParamName = 'bulkDownloadId';
    const urlAppendString = 'bulk_download';

    let userOrTeam: 'User' | 'Team';
    if ('userId' in event && 'email' in event) {
      userOrTeam = 'User';
    }
    if ('id' in event && 'name' in event) {
      userOrTeam = 'Team';
    }

    const serviceMethod = selected
      ? `addViewable${userOrTeam}`
      : `removeViewable${userOrTeam}`;

    this.permissionsService[serviceMethod](
      userId || teamId,
      permissionId,
      postParamName,
      urlAppendString
    ).subscribe(() => this.getBulkDownloadDetails());
  }
}
